"use strict";

var _regeneratorRuntime = require("/home/boetker/workspace/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWatchRequests = exports.authenticatedPutRequest = exports.authenticatedPostRequest = exports.authenticatedGetRequest = exports.authenticatedDeleteRequest = exports.authenticated = void 0;
exports.deleteEffect = deleteEffect;
exports.deleteRequest = deleteRequest;
exports.effectMap = void 0;
exports.getCurrentClubId = getCurrentClubId;
exports.getEffect = getEffect;
exports.getFileEffect = getFileEffect;
exports.getRequest = getRequest;
exports.postEffect = postEffect;
exports.postRequest = postRequest;
exports.prependClubsUrl = prependClubsUrl;
exports.putEffect = putEffect;
exports.putRequest = putRequest;
exports.setPathApiBase = void 0;

require("whatwg-fetch");

var _fp = _interopRequireDefault(require("lodash/fp"));

var _reduxSaga = require("redux-saga");

var _effects = require("redux-saga/effects");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(wrapFetch),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(getRequest),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(postRequest),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(putRequest),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(deleteRequest),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(requestEffect),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(getEffect),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(putEffect),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(postEffect),
    _marked10 = /*#__PURE__*/_regeneratorRuntime.mark(deleteEffect),
    _marked11 = /*#__PURE__*/_regeneratorRuntime.mark(getFileEffect),
    _marked12 = /*#__PURE__*/_regeneratorRuntime.mark(requestEffectInternal),
    _marked13 = /*#__PURE__*/_regeneratorRuntime.mark(getEffectInternal),
    _marked14 = /*#__PURE__*/_regeneratorRuntime.mark(postEffectInternal),
    _marked15 = /*#__PURE__*/_regeneratorRuntime.mark(putEffectInternal),
    _marked16 = /*#__PURE__*/_regeneratorRuntime.mark(deleteEffectInternal),
    _marked17 = /*#__PURE__*/_regeneratorRuntime.mark(getCurrentClubId),
    _marked18 = /*#__PURE__*/_regeneratorRuntime.mark(prependClubsUrl);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // import { selectors as authSelectors } from '../reducers/auth'
// import { selectors as clubsSelectors } from '../reducers/clubs'


var authSelectors = {
  getToken: _fp.default.flow(_fp.default.get('auth'), _fp.default.get('token'))
};
var clubsSelectors = {
  getActive: _fp.default.flow(_fp.default.get('router.location.pathname'), _fp.default.split('/'), _fp.default.get(1))
};
var PATH_API_BASE;

var setPathApiBase = function setPathApiBase(p) {
  PATH_API_BASE = p;
};
/**
 * Wrapper around `fetch`.
 *
 * Returns { error } if the `response` is unsuccessful ~ ![200;300)
 * NEVER throws exceptions.
 */


exports.setPathApiBase = setPathApiBase;

function wrapFetch(url, options) {
  var response, json, md5, token;
  return _regeneratorRuntime.wrap(function wrapFetch$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          response = {};
          _context.prev = 1;
          _context.next = 4;
          return window.fetch(url, options);

        case 4:
          response = _context.sent;
          _context.next = 10;
          break;

        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", {
            error: {
              status: 503,
              statusText: 'Service unavailable'
            }
          });

        case 10:
          json = {};

          if (!(_fp.default.get(['_bodyBlob', 'type'], response) === 'application/x-md5' || _fp.default.head(_fp.default.get(['headers', 'map', 'content-type'], response)) === 'application/x-md5')) {
            _context.next = 23;
            break;
          }

          _context.prev = 12;
          _context.next = 15;
          return response.text();

        case 15:
          md5 = _context.sent;
          json = {
            md5: md5
          };
          _context.next = 21;
          break;

        case 19:
          _context.prev = 19;
          _context.t1 = _context["catch"](12);

        case 21:
          _context.next = 31;
          break;

        case 23:
          _context.prev = 23;
          _context.next = 26;
          return response.json();

        case 26:
          json = _context.sent;
          _context.next = 31;
          break;

        case 29:
          _context.prev = 29;
          _context.t2 = _context["catch"](23);

        case 31:
          if (!response.ok) {
            _context.next = 36;
            break;
          }

          token = response.headers.get('X-Auth-Token');

          if (!token) {
            _context.next = 35;
            break;
          }

          return _context.abrupt("return", _objectSpread(_objectSpread({}, json), {}, {
            token: token
          }));

        case 35:
          return _context.abrupt("return", json);

        case 36:
          if (!_fp.default.isEmpty(json)) {
            _context.next = 38;
            break;
          }

          return _context.abrupt("return", {
            error: {
              status: response.status,
              statusText: response.statusText
            }
          });

        case 38:
          return _context.abrupt("return", {
            error: {
              status: response.status,
              statusText: response.statusText,
              body: json
            }
          });

        case 39:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 7], [12, 19], [23, 29]]);
}
/**
 * Builds options for the `fetch` function.
 *
 * - Add content type `application/json`
 * - Stringify the `body` if present
 */


var decorateOptions = function decorateOptions() {
  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'get';
  var body = arguments.length > 1 ? arguments[1] : undefined;
  var otherHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var loadedAt = arguments.length > 3 ? arguments[3] : undefined;
  var token = arguments.length > 4 ? arguments[4] : undefined;
  var noHeaders = arguments.length > 5 ? arguments[5] : undefined;

  var headers = _objectSpread({
    'Content-Type': 'application/json'
  }, otherHeaders);

  if (token) {
    headers['X-Auth-Token'] = token;
  }

  return _objectSpread({
    method: method,
    headers: noHeaders ? {} : headers
  }, body ? {
    body: JSON.stringify(body)
  } : {});
};

function getRequest(url) {
  var _ref,
      body,
      headers,
      loadedAt,
      token,
      noHeaders,
      _args2 = arguments;

  return _regeneratorRuntime.wrap(function getRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _ref = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, body = _ref.body, headers = _ref.headers, loadedAt = _ref.loadedAt, token = _ref.token, noHeaders = _ref.noHeaders;
          _context2.next = 3;
          return (0, _effects.call)(wrapFetch, url, decorateOptions('get', body, headers, loadedAt, token, noHeaders));

        case 3:
          return _context2.abrupt("return", _context2.sent);

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function postRequest(url) {
  var _ref2,
      body,
      headers,
      loadedAt,
      token,
      noHeaders,
      _args3 = arguments;

  return _regeneratorRuntime.wrap(function postRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _ref2 = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {}, body = _ref2.body, headers = _ref2.headers, loadedAt = _ref2.loadedAt, token = _ref2.token, noHeaders = _ref2.noHeaders;
          _context3.next = 3;
          return (0, _effects.call)(wrapFetch, url, decorateOptions('post', body, headers, loadedAt, token, noHeaders));

        case 3:
          return _context3.abrupt("return", _context3.sent);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function putRequest(url) {
  var _ref3,
      body,
      headers,
      loadedAt,
      token,
      noHeaders,
      _args4 = arguments;

  return _regeneratorRuntime.wrap(function putRequest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _ref3 = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {}, body = _ref3.body, headers = _ref3.headers, loadedAt = _ref3.loadedAt, token = _ref3.token, noHeaders = _ref3.noHeaders;
          _context4.next = 3;
          return (0, _effects.call)(wrapFetch, url, decorateOptions('put', body, headers, loadedAt, token, noHeaders));

        case 3:
          return _context4.abrupt("return", _context4.sent);

        case 4:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function deleteRequest(url) {
  var _ref4,
      body,
      headers,
      loadedAt,
      token,
      noHeaders,
      _args5 = arguments;

  return _regeneratorRuntime.wrap(function deleteRequest$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _ref4 = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {}, body = _ref4.body, headers = _ref4.headers, loadedAt = _ref4.loadedAt, token = _ref4.token, noHeaders = _ref4.noHeaders;
          _context5.next = 3;
          return (0, _effects.call)(wrapFetch, url, decorateOptions('delete', body, headers, loadedAt, token, noHeaders));

        case 3:
          return _context5.abrupt("return", _context5.sent);

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
/**
 * Helper function to build authenticated request functions.
 *
 * @param  {function} asyncRequestFunction - request function
 * @param  {string} token - API token
 * @return {function} request function embedding the token as a header
 */


var authenticated = function authenticated(asyncRequestFunction, token) {
  return /*#__PURE__*/_regeneratorRuntime.mark(function subAuthenticated(url) {
    var _ref5,
        body,
        headers,
        loadedAt,
        noHeaders,
        _args6 = arguments;

    return _regeneratorRuntime.wrap(function subAuthenticated$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _ref5 = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {}, body = _ref5.body, headers = _ref5.headers, loadedAt = _ref5.loadedAt, noHeaders = _ref5.noHeaders;
            _context6.next = 3;
            return (0, _effects.call)(asyncRequestFunction, url, {
              body: body,
              headers: headers,
              loadedAt: loadedAt,
              token: token,
              noHeaders: noHeaders
            });

          case 3:
            return _context6.abrupt("return", _context6.sent);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, subAuthenticated);
  });
};

exports.authenticated = authenticated;

var authenticatedGetRequest = function authenticatedGetRequest(token) {
  return authenticated(getRequest, token);
};

exports.authenticatedGetRequest = authenticatedGetRequest;

var authenticatedPostRequest = function authenticatedPostRequest(token) {
  return authenticated(postRequest, token);
};

exports.authenticatedPostRequest = authenticatedPostRequest;

var authenticatedPutRequest = function authenticatedPutRequest(token) {
  return authenticated(putRequest, token);
};

exports.authenticatedPutRequest = authenticatedPutRequest;

var authenticatedDeleteRequest = function authenticatedDeleteRequest(token) {
  return authenticated(deleteRequest, token);
};

exports.authenticatedDeleteRequest = authenticatedDeleteRequest;
var effectMap = {
  get: getEffectInternal,
  put: putEffectInternal,
  post: postEffectInternal,
  delete: deleteEffectInternal
};
exports.effectMap = effectMap;

var createHandleRequest = function createHandleRequest(basePath) {
  var decoratePath = function decoratePath(url) {
    return _fp.default.startsWith('http', url) ? url : "".concat(basePath).concat(_fp.default.startsWith('/', url) ? '' : '/').concat(url);
  };

  return /*#__PURE__*/_regeneratorRuntime.mark(function handleRequest(networkChannel) {
    var _yield$take, outputChan, _yield$take$request, type, _yield$take$request$a, _authenticated, url, _yield$take$request$o, options, internalEffect, _requestEffect, result;

    return _regeneratorRuntime.wrap(function handleRequest$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            if (!true) {
              _context7.next = 27;
              break;
            }

            _context7.next = 3;
            return (0, _effects.take)(networkChannel);

          case 3:
            _yield$take = _context7.sent;
            outputChan = _yield$take.outputChan;
            _yield$take$request = _yield$take.request;
            type = _yield$take$request.type;
            _yield$take$request$a = _yield$take$request.authenticated;
            _authenticated = _yield$take$request$a === void 0 ? true : _yield$take$request$a;
            url = _yield$take$request.url;
            _yield$take$request$o = _yield$take$request.options;
            options = _yield$take$request$o === void 0 ? {} : _yield$take$request$o; // Find the corresponding effect to the type of request

            internalEffect = effectMap[type]; // If the request is unknown, throw error

            if (internalEffect) {
              _context7.next = 16;
              break;
            }

            console.warn("Unknown request method: ".concat(type));
            return _context7.abrupt("continue", 0);

          case 16:
            _context7.next = 18;
            return (0, _effects.call)(internalEffect, {
              authenticated: _authenticated
            });

          case 18:
            _requestEffect = _context7.sent;
            _context7.next = 21;
            return (0, _effects.call)(_requestEffect, decoratePath(url), options);

          case 21:
            result = _context7.sent;
            _context7.next = 24;
            return (0, _effects.put)(outputChan, result);

          case 24:
            outputChan.close();
            _context7.next = 0;
            break;

          case 27:
          case "end":
            return _context7.stop();
        }
      }
    }, handleRequest);
  });
}; // scoped channel accessible by watchRequests and requestEffect


var NETWORK_CHANNEL;

var createWatchRequests = function createWatchRequests(basePath) {
  var handleRequest = createHandleRequest(basePath);
  return /*#__PURE__*/_regeneratorRuntime.mark(function watchRequests() {
    var i;
    return _regeneratorRuntime.wrap(function watchRequests$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return (0, _effects.call)(_reduxSaga.channel, _reduxSaga.buffers.expanding(20));

          case 2:
            NETWORK_CHANNEL = _context8.sent;
            i = 0;

          case 4:
            if (!(i < 10)) {
              _context8.next = 10;
              break;
            }

            _context8.next = 7;
            return (0, _effects.fork)(handleRequest, NETWORK_CHANNEL);

          case 7:
            i++;
            _context8.next = 4;
            break;

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, watchRequests);
  });
};

exports.createWatchRequests = createWatchRequests;

function requestEffect(type, request) {
  var outputChan, requestWithType;
  return _regeneratorRuntime.wrap(function requestEffect$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          // request is an object with these keys:
          //
          // - authenticated (bool)
          // - url (string)
          // - options (object)
          //
          outputChan = (0, _reduxSaga.channel)();
          requestWithType = _objectSpread(_objectSpread({}, request), {}, {
            type: type
          });
          _context9.next = 4;
          return (0, _effects.put)(NETWORK_CHANNEL, {
            outputChan: outputChan,
            request: requestWithType
          });

        case 4:
          return _context9.abrupt("return", outputChan);

        case 5:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked6);
}

function getEffect(request) {
  return _regeneratorRuntime.wrap(function getEffect$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.call)(requestEffect, 'get', request);

        case 2:
          return _context10.abrupt("return", _context10.sent);

        case 3:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked7);
}

function putEffect(request) {
  return _regeneratorRuntime.wrap(function putEffect$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return (0, _effects.call)(requestEffect, 'put', request);

        case 2:
          return _context11.abrupt("return", _context11.sent);

        case 3:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked8);
}

function postEffect(request) {
  return _regeneratorRuntime.wrap(function postEffect$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return (0, _effects.call)(requestEffect, 'post', request);

        case 2:
          return _context12.abrupt("return", _context12.sent);

        case 3:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked9);
}

function deleteEffect(request) {
  return _regeneratorRuntime.wrap(function deleteEffect$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return (0, _effects.call)(requestEffect, 'delete', request);

        case 2:
          return _context13.abrupt("return", _context13.sent);

        case 3:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked10);
}

function getFileEffect(request) {
  return _regeneratorRuntime.wrap(function getFileEffect$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return (0, _effects.call)(requestEffect, 'get/FILE', request);

        case 2:
          return _context14.abrupt("return", _context14.sent);

        case 3:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked11);
} //  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝


function requestEffectInternal(requestFunction) {
  var token;
  return _regeneratorRuntime.wrap(function requestEffectInternal$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return (0, _effects.select)(authSelectors.getToken);

        case 2:
          token = _context15.sent;
          _context15.next = 5;
          return (0, _effects.call)(requestFunction, token);

        case 5:
          return _context15.abrupt("return", _context15.sent);

        case 6:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked12);
}

function getEffectInternal() {
  var _ref6,
      _ref6$authenticated,
      authenticated,
      _args16 = arguments;

  return _regeneratorRuntime.wrap(function getEffectInternal$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _ref6 = _args16.length > 0 && _args16[0] !== undefined ? _args16[0] : {}, _ref6$authenticated = _ref6.authenticated, authenticated = _ref6$authenticated === void 0 ? true : _ref6$authenticated;

          if (!authenticated) {
            _context16.next = 5;
            break;
          }

          _context16.next = 4;
          return (0, _effects.call)(requestEffectInternal, authenticatedGetRequest);

        case 4:
          return _context16.abrupt("return", _context16.sent);

        case 5:
          return _context16.abrupt("return", getRequest);

        case 6:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked13);
}

function postEffectInternal() {
  var _ref7,
      _ref7$authenticated,
      authenticated,
      _args17 = arguments;

  return _regeneratorRuntime.wrap(function postEffectInternal$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          _ref7 = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : {}, _ref7$authenticated = _ref7.authenticated, authenticated = _ref7$authenticated === void 0 ? true : _ref7$authenticated;

          if (!authenticated) {
            _context17.next = 5;
            break;
          }

          _context17.next = 4;
          return (0, _effects.call)(requestEffectInternal, authenticatedPostRequest);

        case 4:
          return _context17.abrupt("return", _context17.sent);

        case 5:
          return _context17.abrupt("return", postRequest);

        case 6:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked14);
}

function putEffectInternal() {
  var _ref8,
      _ref8$authenticated,
      authenticated,
      _args18 = arguments;

  return _regeneratorRuntime.wrap(function putEffectInternal$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          _ref8 = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : {}, _ref8$authenticated = _ref8.authenticated, authenticated = _ref8$authenticated === void 0 ? true : _ref8$authenticated;

          if (!authenticated) {
            _context18.next = 5;
            break;
          }

          _context18.next = 4;
          return (0, _effects.call)(requestEffectInternal, authenticatedPutRequest);

        case 4:
          return _context18.abrupt("return", _context18.sent);

        case 5:
          return _context18.abrupt("return", putRequest);

        case 6:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked15);
}

function deleteEffectInternal() {
  var _ref9,
      _ref9$authenticated,
      authenticated,
      _args19 = arguments;

  return _regeneratorRuntime.wrap(function deleteEffectInternal$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          _ref9 = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {}, _ref9$authenticated = _ref9.authenticated, authenticated = _ref9$authenticated === void 0 ? true : _ref9$authenticated;

          if (!authenticated) {
            _context19.next = 5;
            break;
          }

          _context19.next = 4;
          return (0, _effects.call)(requestEffectInternal, authenticatedDeleteRequest);

        case 4:
          return _context19.abrupt("return", _context19.sent);

        case 5:
          return _context19.abrupt("return", deleteRequest);

        case 6:
        case "end":
          return _context19.stop();
      }
    }
  }, _marked16);
}

function getCurrentClubId() {
  var path, clubId;
  return _regeneratorRuntime.wrap(function getCurrentClubId$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _effects.select)(_fp.default.get('router.location.pathname'));

        case 2:
          path = _context20.sent;
          clubId = _fp.default.get(1, _fp.default.split('/', path));

          if (_fp.default.isInteger(_fp.default.parseInt(10, clubId))) {
            _context20.next = 8;
            break;
          }

          _context20.next = 7;
          return (0, _effects.select)(clubsSelectors.getActive);

        case 7:
          clubId = _context20.sent;

        case 8:
          return _context20.abrupt("return", clubId);

        case 9:
        case "end":
          return _context20.stop();
      }
    }
  }, _marked17);
}

function prependClubsUrl(url, optionalClubId) {
  var clubId;
  return _regeneratorRuntime.wrap(function prependClubsUrl$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          _context21.t0 = optionalClubId;

          if (_context21.t0) {
            _context21.next = 5;
            break;
          }

          _context21.next = 4;
          return getCurrentClubId();

        case 4:
          _context21.t0 = _context21.sent;

        case 5:
          clubId = _context21.t0;

          if (!url) {
            _context21.next = 8;
            break;
          }

          return _context21.abrupt("return", "clubs/".concat(clubId, "/").concat(url));

        case 8:
          return _context21.abrupt("return", "clubs/".concat(clubId));

        case 9:
        case "end":
          return _context21.stop();
      }
    }
  }, _marked18);
}